"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusWithin = void 0;
// inspired by https://gist.github.com/aFarkas/a7e0d85450f323d5e164
var focusWithin = function () {
    var slice = [].slice;
    var removeClass = function (elem) {
        elem.classList.remove('focus-within');
    };
    var update = (function () {
        var running, last;
        var action = function () {
            var element = document.activeElement;
            running = false;
            if (last !== element) {
                last = element;
                slice.call(document.getElementsByClassName('focus-within')).forEach(removeClass);
                while (element && element.classList) {
                    element.classList.add('focus-within');
                    element = element.parentNode;
                }
            }
        };
        return function () {
            if (!running) {
                requestAnimationFrame(action);
                running = true;
            }
        };
    })();
    document.addEventListener('focus', update, true);
    document.addEventListener('blur', update, true);
    update();
    return function () {
        document.removeEventListener('focus', update, true);
        document.removeEventListener('blur', update, true);
    };
};
exports.focusWithin = focusWithin;
//# sourceMappingURL=focus-within.js.map